// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skope-title[data-v-59a79d67]{color:maroon;font-size:2.3em;font-weight:700;-webkit-text-decoration:none;text-decoration:none}.skope-subtitle[data-v-59a79d67],.skope-title[data-v-59a79d67]{font-family:\"Bitter\",Georgia,serif}.skope-subtitle[data-v-59a79d67]{color:#001e6b;font-size:1.2rem;font-weight:bolder}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
